const benefitsSection = `
  <div class="benefits">
    <div class="benefits__list">
      <div class="benefits__benefit">
        <img src="/user/documents/img/ico-truck-clock-orange.svg" />
        <h4>2000 položek skladem</h4>
        <p>dodání do 2.dne při objednávce do 11:00 </p>
      </div>
      <div class="benefits__benefit">
        <img src="/user/documents/img/ico-box-orange.svg" />
        <h4>2 místa k osobnímu odběru v Praze</h4>
        <p>Kavčí hory a Holešovice</p>
      </div>
      <div class="benefits__benefit">
        <img src="/user/documents/img/ico-truck-orange.svg" />
        <h4>DPD a Zásilkovna</h4>
        <p>doprava zdarma nad 2000 Kč</p>
      </div>
      <div class="benefits__benefit">
        <img src="/user/documents/img/ico-pay-card-orange.svg" />
        <h4>Pohodlná platba kartou, Apple pay</h4>
        <p> </p>
      </div>
    </div>
  </div>
`;

export {
  benefitsSection
};